module.exports = __webpack_public_path__ + "static/img-robot-shop-c1dac88b1ebd0d4ec9617b907e20980c.png";